import { toProperCase } from './toProperCase';

export const formatUserName = (first: string | null | undefined, last: string | null | undefined) =>
  toProperCase((first ?? '') + ' ' + (last ?? '')).trim();
